'use client';

import { Checkbox, Field, Label } from '@ctct/summit-core';
import { type ComponentProps } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { type InputOpts } from '../../types';

const CheckboxInput = ({
  formKey,
  registerOpts,
  checkboxLabel,
  className,
  isDisabled,
  ...inputProps
}: InputOpts
  & ComponentProps<typeof Checkbox> & {
    checkboxLabel?: string;
  } & { isDisabled?: boolean }) => {
  const { control } = useFormContext();
  return (
    <Field kind="inline" className={className}>
      <Controller
        name={formKey}
        control={control}
        rules={registerOpts}
        render={({ field: { onChange: handleChange, value } }) => {
          return (
            <Checkbox
              {...inputProps}
              checked={!!value}
              onCheckedChange={handleChange}
              disabled={isDisabled || inputProps?.disabled}
            />
          );
        }}
      />
      <Label className="r:text-xs">{checkboxLabel}</Label>
    </Field>
  );
};

export { CheckboxInput };
